import { Platform } from 'react-native';

import AndroidBridge from './AndroidBridgeModule';

export type { IAndroidBridgeNativeModule } from './AndroidBridge.types';

/**
 * Custom Android bridge for system APIs not exposed by React Native or Expo.
 *
 * Import from `android-bridge` for imperative native reads. In UI prefer the
 * React hooks in `AndroidBridgeProvider` (e.g. `useAndroidBoldText()`) so values
 * stay in sync when the app returns from background (e.g. after changing system
 * settings).
 *
 * iOS and web use stubs — all APIs return safe defaults there.
 */

/**
 * Whether Android's system **Bold text** accessibility setting is enabled.
 *
 * Reads `Configuration.fontWeightAdjustment` (API 31+). React Native measures text
 * at normal weight while Android can render bolder when this is on, which clips the
 * last word in flex layouts — see `AndroidBoldTextAccessibilitySpacer`.
 *
 * Always `false` on iOS, web, and Android &lt; 12.
 */
export function isAndroidBoldTextEnabled(): boolean {
  if (Platform.OS !== 'android') {
    return false;
  }

  // Fail closed: a native read can throw (e.g. React context lost during teardown).
  try {
    return AndroidBridge.isBoldTextEnabled();
  } catch {
    return false;
  }
}
